import type { NextSeoProps } from "next-seo";
import LitePage from "./page-types/LitePage";
import FullPage from "./page-types/FullPage";

export type Meta = {
  title: string | null;
  description: string | null;
  keywords?: string | null;
  image?: string | null;
  path?: string;
  baseUrl?: string;
  isAvailable?: boolean;
  category?: string;
  price?: number;
  instructor?: string;
  releaseDate?: string;
  isHideGoftino?: boolean;
  lite?: boolean;
} & NextSeoProps;

type Props = {
  meta: Meta;
  children: React.ReactNode;
};

export default function Page({ meta, children }: Props) {
  if (meta.lite)
    return (
      <LitePage
        title={meta.title}
        nofollow={meta.nofollow}
        noindex={meta.noindex}
        canonical={meta.canonical}
      >
        {children}
      </LitePage>
    );

  return <FullPage meta={meta}>{children}</FullPage>;
}
